import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { getPartnerTransactions } from "../../slices/partner/action";
import { formatDate } from "../../helpers/formatDate";
import Pagination from "../../Components/Common/Pagination";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap";

const Transactions = ({ statementRef }) => {
  const dispatch = useDispatch();
  const { partnerTransactions, partnerDetails } = useSelector(
    (state) => state.partner
  );
  const { rewardTypeMapping } = useSelector((state) => state.reward);

  const { transactions, totalPages, totalCount } = partnerTransactions;
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [pageSize, setPageSize] = useState(15);

  const toggle = () => setIsOpenModal(!isOpenModal);

  useEffect(() => {
    if (isOpenModal && statementRef) {
      getPartnerTransactionsFunc();
    }
  }, [currentPage, isOpenModal, statementRef]);

  const getPartnerTransactionsFunc = async () => {
    try {
      const data = {
        pageSize: pageSize,
        pageOffset: currentPage - 1,
        filters: {
          statementRef: statementRef,
        },
      };
      await getPartnerTransactions(data, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  const types = {
    sponsorship_discount_contribution: "Discount Sponsorship",
    sponsorship_reward_contribution: "Reward Sponsorship",
  };

  let previousLauncherId = null;

  return (
    <>
      <div className="btn btn-primary btn-sm" onClick={toggle}>
        View
      </div>

      <Offcanvas
        isOpen={isOpenModal}
        toggle={toggle}
        direction="end"
        style={{ width: "90vw" }}
      >
        <OffcanvasHeader toggle={toggle} className="border-bottom pb-3">
          Transactions
        </OffcanvasHeader>
        <OffcanvasBody>
          <div className="px-4 pb-0">
            <div className="table-responsive position-relative d-flex flex-column">
              <table className="table table-nowrap table-centered align-middle mb-0">
                <thead className="bg-light text-muted fs-14">
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Order Id</th>
                    <th>Type</th>
                    <th>Reward Type</th>
                    <th>Reward Value</th>
                    <th>Amount</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody className="fs-13">
                  {transactions?.map((transaction, index) => {
                    const isNewLauncherId =
                      previousLauncherId !== transaction?.launcherId;
                    previousLauncherId = transaction?.launcherId;

                    return (
                      <React.Fragment key={index}>
                        {isNewLauncherId && (
                          <tr className="table-primary">
                            <td colSpan="8" className="fw-bold text-center">
                              {transaction?.description}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>{index + 1}</td>
                          <td>#{transaction?.transactionId}</td>
                          <td>{transaction?.orderId}</td>
                          <td>
                            {types?.[transaction?.transactionType] || "-"}
                          </td>
                          <td>
                            {rewardTypeMapping?.[transaction?.rewardTypeId]
                              ?.name || "-"}
                          </td>
                          <td>
                            {transaction?.rewardValue
                              ? `${transaction?.rewardValue} Pts`
                              : "-"}
                          </td>
                          <td>
                            {partnerDetails?._d ===
                            transaction?.receiverPartyId ? (
                              <span className="pe-1 text-success">+</span>
                            ) : (
                              <span className="pe-1 text-danger fs-16">-</span>
                            )}
                            AED {transaction?.transactionValue}
                          </td>
                          <td>{formatDate(transaction?.createdAt, true)}</td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination
              totalPages={totalPages}
              totalItems={totalCount}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              itemsPerPage={pageSize}
            />
          </div>
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default Transactions;
